var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_143_47527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 40C23.45 40 22.9793 39.8043 22.588 39.413C22.1967 39.0217 22.0007 38.5507 22 38V20C22 19.45 22.196 18.9793 22.588 18.588C22.98 18.1967 23.4507 18.0007 24 18H34C34.55 18 35.021 18.196 35.413 18.588C35.805 18.98 36.0007 19.4507 36 20V23.1C36.3 23.2167 36.5417 23.4 36.725 23.65C36.9083 23.9 37 24.1833 37 24.5V26.5C37 26.8167 36.9083 27.1 36.725 27.35C36.5417 27.6 36.3 27.7833 36 27.9V38C36 38.55 35.8043 39.021 35.413 39.413C35.0217 39.805 34.5507 40.0007 34 40H24ZM24 38H34V20H24V38ZM29 23C29.2833 23 29.521 22.904 29.713 22.712C29.905 22.52 30.0007 22.2827 30 22C29.9993 21.7173 29.9033 21.48 29.712 21.288C29.5207 21.096 29.2833 21 29 21C28.7167 21 28.4793 21.096 28.288 21.288C28.0967 21.48 28.0007 21.7173 28 22C27.9993 22.2827 28.0953 22.5203 28.288 22.713C28.4807 22.9057 28.718 23.0013 29 23Z",
    fill: "#F26064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_143_47527",
    x: 0.3,
    y: 0.3,
    width: 57.4,
    height: 57.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_47527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_47527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon1);
export default __webpack_public_path__ + "static/media/webIcon1.f7ee0b535c0ff0ede5d1bf3c522a0609.svg";
export { ForwardRef as ReactComponent };